// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const DeleteList: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="11" viewBox="0 0 9 11">
            <path
                fill="currentColor"
                d="M8.82649161,9.26997645 C9.09156968,9.58825738 9.04877307,10.0609921 8.73053862,10.3260701 C8.59028842,10.4428828 8.41999175,10.5000232 8.25077297,10.5000232 C8.03580429,10.5000232 7.8225701,10.4081014 7.67444493,10.2300235 L4.49992897,6.40122659 L1.32649161,10.2098203 C1.17817904,10.3878046 0.965085403,10.4798201 0.750163571,10.4798201 C0.580968396,10.4798201 0.410788671,10.4226797 0.270397917,10.305867 C-0.0478833754,10.040789 -0.0907740433,9.56805427 0.174444572,9.24977333 L3.52366318,5.23024208 L0.173881666,1.23091395 C-0.0912668545,0.912632296 -0.0484230359,0.439898321 0.26992871,0.174820253 C0.587741153,-0.0909609107 1.06047548,-0.0482107906 1.3260224,0.270773241 L4.49992861,4.0785702 L7.67336597,0.269976446 C7.93820943,-0.0483044891 8.41117872,-0.0914301185 8.72945966,0.174023459 C9.04774059,0.439101526 9.09063162,0.911835501 8.82541265,1.23011715 L5.47619404,5.2496484 L8.82649125,9.26997645 L8.82649161,9.26997645 Z"
                transform="translate(0 .25)"
            />
        </svg>
    );
};

export default React.memo(DeleteList);
